import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-scheduled-reports",
	templateUrl: "./scheduled-reports.component.html",
	styleUrls: ["./scheduled-reports.component.css"],
})
export class ScheduledReportsComponent implements OnInit {
	constructor() {}
	ngOnInit(): void {}

	////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////

	SelectedJob: any;

	////////////////////////////////////////////////////

	////////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////////

	onJobSelected(val) {
		this.SelectedJob = val;
	}

	////////////////////////////////////////////////////
}
